import hero1 from '../../assets/img/hero1.webp';
import iconLinkedIn from '../../assets/img/icon-linkedin.webp';
import iconTwitter from '../../assets/img/icon-twitter.webp';
import iconGitHub from '../../assets/img/icon-github.webp';
import H3Header from '../UI/H3Header';
import IconWhite from '../UI/IconWhite';
import TechStack from '../UI/TechStack';

const AboutMe = props => {
    return (
        <div class="mt-32 flex gap-6 max-w-5xl mx-auto text-white px-2 flex-wrap md:flex-nowrap">
            <div data-theme="mytheme" class="mx-auto">
                <div>
                    <img src={hero1} alt='Marco Eidinger in front of a wall.' class='max-w-xs' />
                </div>
                <div class="w-4/5 mx-auto mt-14 flex justify-around">
                    <IconWhite icon={iconLinkedIn} goTo='http://www.linkedin.com/pub/marco-eidinger/12/8a5/609/' ariaLabel='LinkedIn'>LinkedIn</IconWhite>
                    <IconWhite icon={iconTwitter} goTo='https://twitter.com/marcoeidinger' ariaLabel='Twitter'>Twitter</IconWhite>
                    <IconWhite icon={iconGitHub} goTo='https://github.com/MarcoEidinger' ariaLabel='GitHub'>GitHub</IconWhite>
                </div>
            </div>
            <div class="">
                <H3Header>
                    {props.projectTitle}
                </H3Header>
                {props.children}
                <h4 class="text-xl font-bold mt-5 mb-3">My tech stack</h4>
                <p data-theme="mytheme" class="text-secondary mb-5">I'm proficient with the following relevant technologies:</p>
                <div class="grid grid-cols-5 gap-4">
                    <TechStack usedTech={props.techStack} />
                </div>
            </div>
        </div>
    );
};

export default AboutMe;
